import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FailedPaymentsRestrictedComponent } from './failed-payments-restricted.component';

const routes: Routes = [{ path: 'restricted', component: FailedPaymentsRestrictedComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FailedPaymentsRoutingModule {}
